import { buildReloadUrl } from '@tfa/shared'

/**
 * Перезагрузка Mini App на свежую сборку.
 *
 * URL обязан отличаться от текущего КАЖДЫЙ раз, иначе перезагрузки может не
 * случиться: replace() на идентичный URL с фрагментом — это same-document
 * навигация (проверено в браузере), а Telegram Desktop переоткрывает Mini App
 * по сохранённому адресу, где ?v=<buildId> уже стоит с прошлой попытки.
 * Уникальный параметр заодно пробивает кеш index.html в WebView.
 * Хеш переносим: в нём Telegram передаёт launch params (#tgWebAppData=…).
 */
export function hardReload(buildId: string): void {
  const nonce = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`
  const url = buildReloadUrl(buildId, window.location.hash, nonce)

  // Telegram Desktop молча игнорировал replace() — отсюда лесенка фолбэков.
  // Если переход состоялся, документ выгружается и таймеры не доживают;
  // если код продолжает исполняться — значит навигации не было, пробуем жёстче.
  const go = (fn: () => void) => { try { fn() } catch { /* пробуем следующий способ */ } }
  go(() => window.location.replace(url))
  window.setTimeout(() => go(() => window.location.assign(url)), 400)
  window.setTimeout(() => go(() => window.location.reload()), 1200)
}
